import { Route } from "@angular/router";
import { PainelOfertasPage } from "./painel-ofertas.page";

export const PainelOfertasRouter: Route[] = [
  { path: 'painel-ofertas', component: PainelOfertasPage }
];
